import { render, staticRenderFns } from "./PreviewSort.vue?vue&type=template&id=06b4f749"
import script from "./PreviewSort.vue?vue&type=script&lang=js"
export * from "./PreviewSort.vue?vue&type=script&lang=js"
import style0 from "./PreviewSort.vue?vue&type=style&index=0&id=06b4f749&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports